const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/client-health/$clientId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { RANGES } from "@/components/client-health/health-bits";
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/client-health/$clientId")({
  beforeLoad: args => requirePermission(Permissions.Dashboard.ViewClientHealth, args),
  validateSearch: (search: Record<string, unknown>): {
    days?: number;
  } => {
    const days = Number(search.days);
    return RANGES.some(r => r.days === days) ? {
      days
    } : {};
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

/** One company's problems (drill-down from Client health). */